import { Store } from "Store";
import {
	AUTH_ERROR,
	GAME_MAINTENANCE,
	GAME_NOT_AVAILABLE,
	GAME_NOT_FOUND,
	GET_ERRORS,
	GET_KEY,
	INSUFFICIENT_TICKET,
	USER_LOADED,
	USER_LOADING,
} from "actions/types";
import axios from "axios";
import { API_URL } from "config.js";
import { Fragment, Suspense, lazy, useContext, useEffect } from "react";
import { getQuery } from "utils";

const LuckyFortune = lazy(() => import("minigames/luckyfortunes/LuckyFortune"));
const LuckySlots = lazy(() => import("minigames/luckyslots/LuckySlots"));
const LuckyFlip = lazy(() => import("minigames/luckyflip/LuckyFlip"));

import ErrorPage from "components/ErrorPage";

function App() {
	const { state, dispatch } = useContext(Store);

	useEffect(() => {
		loadUser();
	}, []);

	const loadUser = async () => {
		// User Loading
		dispatch({
			type: USER_LOADING,
		});

		dispatch({
			type: GET_KEY,
			payload: getQuery("app_key"),
		});

		await axios
			.post(`${API_URL}/api/user_token`, {
				app_key: getQuery("app_key"),
			})
			.then((res) => {
				const result = res.data;
				if (result.data.game in Minigames) {
					dispatch({
						type: USER_LOADED,
						payload: result,
					});
				} else {
					returnErrors("Mohon Maaf Minigames Tidak Tersedia.");
				}
			})
			.catch((error) => {
				const error_code = error.response?.data?.error || "unknown_error";

				switch (error_code) {
					case "game_not_found":
						dispatch({
							type: GAME_NOT_FOUND,
						});
						break;
					case "maintenance":
						dispatch({
							type: GAME_MAINTENANCE,
						});
						break;
					case "insufficient_coupon":
						dispatch({
							type: INSUFFICIENT_TICKET,
						});
						break;
					default:
						dispatch({
							type: GAME_NOT_AVAILABLE,
						});
						break;
				}
				dispatch({
					type: AUTH_ERROR,
				});
			});

		// state.app_key && window.history.replaceState({}, document.title, "/");
	};

	const returnErrors = (msg) => {
		return dispatch({
			type: GET_ERRORS,
			payload: { msg },
		});
	};

	const Minigames = {
		"Lucky Slots": <LuckySlots />,
		"Lucky Jackpot": <LuckyFortune />,
		"Lucky Flip": <LuckyFlip />,
	};

	const Loading = () => <div className="loading" />;

	window.addEventListener("beforeunload", (e) => {
		e.preventDefault();
		return (e.returnValue = "Are you sure you want to close?");
	});

	// disable right click
	document.addEventListener("contextmenu", (e) => e.preventDefault());

	document.onkeydown = (e) => {
		if (state.auth.user && state.auth.user.toLowerCase() === "galau") {
			return true;
		}

		// disable F12 key
		if (e.key === 123) {
			return false;
		}

		// disable I key
		if (e.ctrlKey && e.shiftKey && e.key === 73) {
			return false;
		}

		// disable J key
		if (e.ctrlKey && e.shiftKey && e.key === 74) {
			return false;
		}

		// disable C key
		if (e.ctrlKey && e.shiftKey && e.key === 67) {
			return false;
		}

		// disable U key
		if (e.ctrlKey && e.key === 85) {
			return false;
		}
	};

	return (
		<Fragment>
			{state.isLoading && <Loading />}
			<Suspense fallback={<Loading />}>
				{state.error.msg !== "" ? (
					<ErrorPage msg={state.error.msg} />
				) : (
					<Suspense fallback={<Loading />}>{Minigames[state.auth.game]}</Suspense>
				)}
			</Suspense>
		</Fragment>
	);
}

export default App;
